/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * プルダウンの未選択表示状態。null/undefined の場合は、プルダウンの未選択値の表示はしない。
 */
export interface FormPagePropertyItemMonthDayUnselectedState { 
    /**
     * 未選択値時にプルダウンに表示する値
     */
    valueType: FormPagePropertyItemMonthDayUnselectedState.ValueTypeEnum;
}
export namespace FormPagePropertyItemMonthDayUnselectedState {
    export type ValueTypeEnum = 'hyphen';
    export const ValueTypeEnum = {
        Hyphen: 'hyphen' as ValueTypeEnum
    };
}



